import { Paper, Box, LinearProgress } from "@mui/material";
import PropTypes from "prop-types";
import { lazy, startTransition, useEffect, useState } from "react";

import BetoniOnlinePrintBanner from "src/components/layout/BetoniOnlinePrintBanner";
import MyDivider from "src/components/layout/MyDivider";
import Keksit from "src/components/system/Keksit/Keksit";
import StepModal from "./StepTilaus/Modals/StepModal";
import StepTilausTabs from "./StepTilaus/StepTilausTabs";
import SystemErrorModal from "src/components/system/SystemError/SystemError";
import LazyLoadTxt from "src/components/layout/Progress/LazyLoadTxt";
import { allowChangePumppuToimittaja, allowEditTilausData } from "src/data/ifs/allowIfs";
import { useKeikkaLaskuData } from "src/context/KeikkaLaskuContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";
import {
  saveBetoniToimittajaToDB_exported,
  savePumppuToimittajaToDB,
} from "src/data/keikka/keikkaClass";
import { useUserData } from "src/context/userContext";
import { useKeikkaBetoniData } from "src/context/KeikkaBetoniContext";
import { useNavData } from "src/context/navContext";
import {
  findClosestSijaintiForKeikka,
  setBetoniToimittajaData,
  setPumppuToimittajaData,
} from "src/data/sijainti/sijaintiClass";
import { useStatusData } from "src/context/StatusContext";
import { keikkaBetoni_getBetoni_from_keikkaData_by_keikkaBetoniId } from "src/data/betoni/KeikkaBetoniFunctions";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import KeikkaInfoBanner from "src/components/keikka/KeikkaInfoBanner/KeikkaInfoBanner";
import { useNavigate } from "react-router-dom";
import { tyomaa_fixTyomaaAddresses } from "src/data/tyomaa/tyomaaFunctions";
import { keikkaTila_saveSetToDB, keikkaTila_saveToDB } from "src/data/tilaClass";
import { useTarjousData } from "src/context/TarjousContext";
import keikkaEval from "src/data/keikkaLasku/keikkaEval";
import { keikkaLaskuStatusType_getName } from "src/data/keikkaLasku/keikkaLaskuClass";
import { addStepLogMessage } from "src/data/keikka/handleKeikka";
import { keikka_fixTyomaaAsiakas } from "src/data/keikka/KeikkaFunctions";

const StepAikaModal = lazy(() => import("./StepAika/StepAikaModal"));
const Kirjaudu = lazy(() => import("src/components/login/Kirjaudu/Kirjaudu"));
const ToimittajaSelectorForTyomaaModal = lazy(() =>
  import("src/components/toimittaja/ToimittajaSelectorForTyomaa/ToimittajaSelectorForTyomaaModal")
);

const _stepBetoni = import("./StepBetoni/StepBetoni");
const StepBetoni = lazy(() => _stepBetoni);

const _stepM3 = import("./StepM3/StepM3");
const StepM3 = lazy(() => _stepM3);

const _stepOsoite = import("./StepOsoite/StepOsoite");
const StepOsoite = lazy(() => _stepOsoite);

const _stepPumi = import("./StepPumi/StepPumi");
const StepPumi = lazy(() => _stepPumi);

const _askToSaveDialog = import("./StepTilaus/Modals/AskToSaveDialog");
const AskToSaveDialog = lazy(() => _askToSaveDialog);

const styles = { fullHeight: { height: "calc(100vh - 150px)" } };

const stepId_määrä = 0;
const stepId_osoite = 1;
const stepId_pumppu = 2;
const stepId_aika = 3;
const stepId_betoni = 4;
// eslint-disable-next-line no-unused-vars
const stepId_lattia = 5;
const stepId_yhteenveto = 6;
// eslint-disable-next-line no-unused-vars
const stepId_process = 7;
const stepId_toimittajaSelector = 8;
const stepId_betoniM3 = 9;
const stepId_betoniJaM3 = 10;

export default function Steps() {
  const {
    keikkaData,
    doSetKeikkaData,
    isChanged,
    laskuttajaAsiakas,
    origKeikkaData,
    doSetOrigKeikkaData,
    reloadKeikkaData,
    isKeikkaDataLoaded,
  } = useKeikkaData();
  const keikkaId = keikkaData.keikkaId;
  const navigate = useNavigate();
  const { mainTarjous } = useTarjousData();
  const { user, token, socket, isLoggedIn, userAsiakas } = useUserData();
  const { keikkaBetoniId, doSetKeikkaBetoniId: setKeikkaBetoniId } = useKeikkaBetoniData();
  const { keikkaLasku, doSetKeikkaLasku } = useKeikkaLaskuData();
  const { isLoadedPercent, isLoaded } = useStatusData();

  const {
    stepId,
    doSetStepId: setStepId,
    tabValue,
    navToYhteenveto,
    navToBetoniM3,
    navToBetoniJaM3,
    navToToimittajaSelector,
  } = useNavData();
  const [confirmSaveIsOpen, setConfirmSaveIsOpen] = useState(false);

  // non-urgent UI renders
  startTransition(() => {
    const keikkaId = keikkaData.keikkaId;
    document.title = "Tilaus " + keikkaId + (keikkaData ? " / " + keikkaData.varmenne : "");
    localStorage.setItem("lastKnownUrl", window.location.pathname);
  }, []);

  // check keikkaData.tila.isLaskutusSet
  useEffect(() => {
    if (!keikkaData || !keikkaData.laskutus || !mainTarjous || !keikkaLasku) return;
    const asynk = async () => {
      // check if keikkaData.tila.isLaskutusSet === false and keikkaData.tila.keikkaTilaCatetory is "valmis" or "muu"
      // then check tarjous to see if laskutus is needed
      if (
        !keikkaData.tila.isLaskutusSet &&
        (keikkaData.tila.keikkaTilaCategory === "valmis" ||
          keikkaData.tila.keikkaTilaCategory === "muu")
      ) {
        const evalResult = keikkaEval(mainTarjous.evalCriteria, keikkaData);
        const laskutetaan = evalResult.result.bool;
        // set isLaskutusSet
        keikkaData.tila.isLaskutusSet = true;
        // set keikkaLaskuStatusTypeId
        keikkaLasku.keikkaLaskuStatusTypeId = laskutetaan ? 5 : 1;
        keikkaLasku.keikkaLaskuStatusTypeName = keikkaLaskuStatusType_getName(
          keikkaLasku.keikkaLaskuStatusTypeId
        );
        // set new keikkaTilaId if toimitettu and laskutettu
        if (keikkaData.tila.keikkaTilaId === 9 && laskutetaan) {
          const _tila = 13; // toimitettu, odottaa laskutusta
          keikkaData.tila.keikkaTilaId = _tila;
          keikkaTila_saveToDB(keikkaData.keikkaId, _tila, user.personId, token, socket);
        }
        // set state
        doSetKeikkaData(keikkaData);
        doSetKeikkaLasku(keikkaLasku);
        // save to db
        keikkaLasku.saveKeikkaLaskuToDB(token);
        keikkaTila_saveSetToDB(keikkaData, token);
        // add log message
        addStepLogMessage(
          keikkaData,
          socket,
          user.personId,
          "Laskutus asetettu automaattisesti Steps.jsx:useEffect : " +
            keikkaLasku.keikkaLaskuStatusTypeName,
          30
        );
      }
      // check if keikkaData.tyomaa.asiakasId !== keikkaData.tyomaa.asiakasId
      // then execute procedure fix_asiakastyomaa
      if (keikkaData.asiakas.asiakasId !== keikkaData.tyomaa.asiakasId) {
        console.log("Fixing tyomaa asiakas");
        await keikka_fixTyomaaAsiakas(keikkaData.keikkaId, token);
        // reload tyomaa
        await reloadKeikkaData();
        return;
      }
    };
    asynk();
  }, [keikkaId, keikkaData.laskutus, mainTarjous, keikkaLasku]);

  useEffect(() => {
    localStorage.removeItem("lastKnownUrl");
  }, []);

  // Check valid tyomaa and fix tyomaa addresses
  useEffect(() => {
    if (!keikkaData) return;
    if (!keikkaData.tyomaa) return;
    if (!isLoaded) return;
    const asynk = async () => {
      const addressGotFixed = await tyomaa_fixTyomaaAddresses(
        keikkaData.tyomaa,
        token,
        keikkaData.keikkaId
      );
      if (addressGotFixed) await reloadKeikkaData();
    };
    asynk();
  }, [isLoaded, keikkaData, keikkaData?.tyomaa]);

  // check if betoniToimittaja or pumppuToimittaja is 0 and if so then find closest sijainti
  // and set betoniToimittaja and pumppuToimittaja
  useEffect(() => {
    if (!keikkaData) return;
    if (!user) return;
    if (keikkaData.isLoading) return;
    const asynk = async () => {
      if (
        keikkaData &&
        keikkaData.pumppuToimittaja?.asiakasId > 0 &&
        keikkaData.betoniToimittaja?.asiakasId > 0
      ) {
        if (
          keikkaData.pumppuToimittaja.asiakasId === 0 ||
          keikkaData.betoniToimittaja.asiakasId === 0
        ) {
          const a = await findClosestSijaintiForKeikka(
            keikkaData,
            user.personId,
            userAsiakas?.asiakasId,
            token
          );
          if (keikkaData.pumppuToimittaja.asiakasId === 0) {
            console.log("Setting new pumppuToimittaja");
            setPumppuToimittajaData(
              keikkaData,
              user,
              a.pumppuAsiakasId,
              a.pumppuSijaintiId,
              a.pumppuMatkaM,
              a.pumppuMatkaAika,
              token
            );
            await savePumppuToimittajaToDB(keikkaData, token);
          }
          if (keikkaData.betoniToimittaja.asiakasId === 0) {
            console.log("Setting new betoniToimittaja");
            setBetoniToimittajaData(
              keikkaData,
              user,
              a.betoniAsiakasId,
              a.betoniSijaintiId,
              a.betoniMatkaM,
              a.betoniMatkaAika,
              token,
              laskuttajaAsiakas.asiakasId
            );
            await saveBetoniToimittajaToDB_exported(keikkaData, token, socket, user.personId);
          }
          doSetKeikkaData(keikkaData);
        }
      }
    };
    asynk();
  }, [
    keikkaData?.pumppuToimittaja?.asiakasId,
    keikkaData?.betoniToimittaja?.asiakasId,
    user,
    keikkaData,
    keikkaData?.isLoading,
  ]);

  if (!isLoggedIn)
    return (
      <LazyLoader>
        <Kirjaudu keikkaId={keikkaId} />
      </LazyLoader>
    );

  if (!keikkaData) return <LazyLoadTxt txt="Ladataan tilaus" />;
  if (keikkaData.keikkaId === undefined) return <LazyLoadTxt txt="Ladataan tilaus" />;
  if (keikkaData.errors.hasError) {
    return (
      <>
        <SystemErrorModal
          errorTxt={keikkaData.errors.errorTxt}
          errorNum={keikkaData.errors.errorNum}
        />
        <div style={styles.fullHeight}></div>
      </>
    );
  }

  return (
    <>
      <Keksit />
      <AskToSaveDialog
        open={confirmSaveIsOpen}
        onClose={() => {
          setConfirmSaveIsOpen(false);
          navToYhteenveto();
        }}
        setKeikkaData={() => {
          doSetOrigKeikkaData(keikkaData);
          doSetKeikkaData(keikkaData);
        }}
        keikkaData={keikkaData}
        stepId={stepId}
        origKeikkaData={origKeikkaData}
        reloadKeikkaData={reloadKeikkaData}
        keikkaBetoniId={keikkaData.betoniId}
      />
      {allowChangePumppuToimittaja && (
        <LazyLoader>
          <ToimittajaSelectorForTyomaaModal
            isOpen={stepId == stepId_toimittajaSelector && keikkaData.asiakasId > 0}
            onClose={async () => {
              doSetOrigKeikkaData(keikkaData);
              navToYhteenveto();
              await reloadKeikkaData();
            }}
            doFindClosestSijaintiForKeikka={true}
          />
        </LazyLoader>
      )}
      {/* stepM3 modal */}
      {keikkaData.modules.hasBetoni && (
        <StepModal
          open={
            stepId === stepId_betoniM3 || stepId === stepId_betoniJaM3 || stepId === stepId_määrä
          }
          onSaveKlik={handleStepM3Save}
          onCancelKlik={(askToSave) => handleStepM3Cancel(askToSave)}
          onClose={() => {}}
          aria-labelledby="Betonin määrä valinta"
          aria-describedby="Paljonko betonia tarvitset?"
          title="Betonin määrä"
          helpId="m3"
          editMode={allowEditTilausData(keikkaData)}
          showMuokkausTilaButton={keikkaData.showMuokkausTilaButtonInModal}>
          <LazyLoader>
            <StepM3 doSave={handleStepM3Save} />
          </LazyLoader>
        </StepModal>
      )}
      {/* stepAika modal */}
      <LazyLoader>
        <StepAikaModal
          isOpen={stepId == stepId_aika}
          onSaved={() => reloadKeikkaData()}
          onClose={() => navToYhteenveto()}
        />
      </LazyLoader>
      {/* stepBetoni modal */}
      {keikkaData.modules.hasBetoni && (
        <StepModal
          open={stepId == stepId_betoni || stepId == stepId_betoniJaM3}
          onSaveKlik={handleStepBetoniSave}
          onCancelKlik={(askToSave) => HandleStepBetoniCancel(askToSave)}
          onClose={() => {}}
          aria-labelledby="Betonin laatuvalinta"
          aria-describedby="Betonin ominaisuuksien valinta"
          title="Betonin tiedot"
          editMode={allowEditTilausData(keikkaData)}
          showMuokkausTilaButton={keikkaData.showMuokkausTilaButtonInModal}>
          <LazyLoader>
            <StepBetoni onEditM3Klik={() => navToBetoniJaM3()} />
          </LazyLoader>
        </StepModal>
      )}
      {/* stepOsoite modal */}
      <StepModal
        open={stepId == stepId_osoite}
        onSaveKlik={async () => await HandleStepOsoiteSave()}
        onCancelKlik={async (askToSave) => HandleStepOsoiteCancel(askToSave)}
        onClose={() => {}}
        aria-labelledby="Osoite ja asiakastiedot"
        aria-describedby="Osoite ja asiakastiedot"
        title="Osoite ja asiakastiedot"
        editMode={allowEditTilausData(keikkaData)}
        showMuokkausTilaButton={keikkaData.showMuokkausTilaButtonInModal}>
        <LazyLoader>
          <StepOsoite />
        </LazyLoader>
      </StepModal>
      {/* stepPumppu modal */}
      {keikkaData.modules.hasPumppu && (
        <StepModal
          open={stepId == stepId_pumppu}
          onSaveKlik={HandleStepPumppuSave}
          onCancelKlik={(askToSave) => HandleStepPumppuCancel(askToSave)}
          onClose={() => {}}
          aria-labelledby="Puomin puomi ja linjavalinta"
          aria-describedby="Valitse puomin ja linjan pituus"
          title="Pumppu, puomi ja linja"
          editMode={allowEditTilausData(keikkaData)}
          showMuokkausTilaButton={keikkaData.showMuokkausTilaButtonInModal}>
          <LazyLoader>
            <StepPumi />
          </LazyLoader>
        </StepModal>
      )}
      {!isKeikkaDataLoaded.finalize && (
        <div style={{ position: "absolute", width: "100%", zIndex: "2" }}>
          <LinearProgress value={isLoadedPercent} variant="determinate" />
        </div>
      )}
      <Box className="boxContainer">
        <KeikkaInfoBanner
          keikkaData={keikkaData}
          navTo={(nt) => (nt === stepId_määrä ? navToBetoniM3() : setStepId(nt))} // kun klikataan m3 nappia niin älä siirry tästä pois
          setKeikkaBetoniId={setKeikkaBetoniId}
          user={user}
          keikkaLasku={keikkaLasku}
        />
        <BetoniOnlinePrintBanner /> {/* tämä banneri näkyy vain printattavassa versiossa */}
        <Paper elevation={3} className="paperContainer">
          <StepTilausTabs
            navTo={(nt) => (nt === stepId_määrä ? navToBetoniM3() : setStepId(nt))} // kun klikataan m3 nappia niin älä siirry tästä pois
            isAuthenticated={isLoggedIn}
            value={tabValue}
            stepId={stepId}
            onLeftButtonKlik={() => {
              navigate("/");
            }}
          />
        </Paper>
        <MyDivider gutter gutterHeight="12px" noPrint />
      </Box>
    </>
  );

  // when user click cancel button on stepM3 modal
  function handleStepM3Cancel(askToSave) {
    const targetStepId = stepId == stepId_betoniJaM3 ? stepId_betoni : stepId_yhteenveto;
    if (isChanged()) {
      // data has been changed
      if (askToSave) {
        // user clicked on close icon
        // open confirm save modal
        setConfirmSaveIsOpen(true);
      } else {
        // user clicked on peruuta button
        // undo changes and close modal
        keikkaData.handleChange.undoStepM3(keikkaData, origKeikkaData.keikkaData, keikkaBetoniId);
        doSetOrigKeikkaData(keikkaData);
        setStepId(targetStepId);
      }
    } else {
      // no changed made, close modal
      setStepId(targetStepId);
    }
  }

  // user clicked on tallenna button on stepM3 modal
  async function handleStepM3Save() {
    const targetStepId = stepId == stepId_betoniJaM3 ? stepId_betoni : stepId_yhteenveto;
    if (isChanged()) {
      // data has been changed, save to db
      const origBetoni = keikkaBetoni_getBetoni_from_keikkaData_by_keikkaBetoniId(
        origKeikkaData,
        keikkaBetoniId
      );
      setStepId(targetStepId);
      await keikkaData.handleChange.saveStepM3ToDB(
        keikkaData.getBetoni(keikkaBetoniId),
        token,
        true,
        true,
        origBetoni.m3,
        socket,
        user.personId
      ); // don't await
      doSetOrigKeikkaData(keikkaData);
    } else {
      // close modal
      setStepId(targetStepId);
    }
  }

  // user clicked on peruuta button on stepBetoni modal
  async function HandleStepBetoniCancel(askToSave) {
    if (isChanged()) {
      if (askToSave) {
        setConfirmSaveIsOpen(true);
      } else {
        await reloadKeikkaData();
        navToYhteenveto();
      }
    } else navToYhteenveto();
  }

  // user clicked on tallenna button on stepOsoite modal
  async function HandleStepOsoiteCancel(askToSave) {
    if (isChanged()) {
      if (askToSave) {
        setConfirmSaveIsOpen(true);
      } else {
        await reloadKeikkaData();
        navToYhteenveto();
      }
    } else navToYhteenveto();
  }

  // user clicked on tallenna button on stepOsoite modal
  async function HandleStepOsoiteSave() {
    if (isChanged()) {
      await keikkaData.handleChange.saveStepOsoiteToDB(
        keikkaData,
        token,
        socket,
        origKeikkaData.keikkaData,
        user.personId
      );
      if (keikkaData.tyomaa.tyomaaId != origKeikkaData.keikkaData.tyomaa.tyomaaId) {
        navToToimittajaSelector();
      } else {
        await reloadKeikkaData();
        navToYhteenveto();
      }
    } else navToYhteenveto();
  }

  // user clicked on peruuta button on stepPumppu modal
  function HandleStepPumppuCancel(askToSave) {
    if (isChanged()) {
      if (askToSave) {
        setConfirmSaveIsOpen(true);
      } else {
        keikkaData.handleChange.undoStepPumppu(keikkaData, origKeikkaData.keikkaData);
        doSetOrigKeikkaData(keikkaData);
        navToYhteenveto();
      }
    } else navToYhteenveto();
  }

  // user clicked on tallenna button on stepPumppu modal
  async function HandleStepPumppuSave() {
    navToYhteenveto();
    if (isChanged()) {
      await keikkaData.handleChange.saveStepPumppuToDB(
        token,
        socket,
        origKeikkaData.keikkaData,
        user.personId
      );
      doSetOrigKeikkaData(keikkaData);
    }
  }

  // user clicked on tallenna button on stepBetoni modal
  async function handleStepBetoniSave() {
    setStepId(stepId_yhteenveto);
    if (isChanged()) {
      await keikkaData.handleChange.saveAllBetoniChangesToDB(
        keikkaData.getBetoni(keikkaBetoniId),
        keikkaBetoni_getBetoni_from_keikkaData_by_keikkaBetoniId(origKeikkaData, keikkaBetoniId),
        token,
        socket,
        user.personId
      );
      doSetOrigKeikkaData(keikkaData);
    }
  }
}

Steps.propTypes = {
  keikkaId: PropTypes.number,
  leftButtonKlik: PropTypes.func,
  leftButtonText: PropTypes.string,
  hideRightButton: PropTypes.bool,
  isConnected: PropTypes.bool,
};
